import React, { useState } from 'react'
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { checkUserAvailability } from '../../../services/api/authApis';
import AdditionalDataModal from './AdditionalDataModal';
import { useDispatch } from 'react-redux';
import { socailLogin } from '../../../redux/reducers/authSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactFacebookLogin from 'react-facebook-login';


const SocialSignIn = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation()


    const [isOpen, setIsOpen] = useState(false);
    const [dataRequired, setDataRequired] = useState('');
    const [localBodyData, setLocalBodyData] = useState(null);
    const parseJwt = (token) => {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    };
    const handleCredentialResponse = async (data) => {
        let decodedData = parseJwt(data.credential)
        socialLoginCallBackData(decodedData)

    }

    const socialLoginCallBackData = async (data) => {
        if (data) {
            let bodyData = {}
            if (data.sub) {
                bodyData.googleId = data.sub
            }
            let userAvailabity = await checkUserAvailability(bodyData)
            if (userAvailabity?.result?.isUser) {
                bodyData.isUser = userAvailabity?.result?.isUser
                bodyData.googleId = data.sub
                // bodyData.facebookId = ''
            }
            else {
                bodyData.isUser = userAvailabity?.result?.isUser
                bodyData.googleId = data.sub
                bodyData.facebookId = ''
                bodyData.socialType = data.sub ? 'Google' : 'Facebook'
                bodyData.email = data?.email
                // bodyData.phoneNumber = ''
                bodyData.fname = data?.given_name
                bodyData.lname = data?.family_name
                bodyData.name = data?.name

            }
            dispatch(socailLogin({ values: bodyData, navigate: navigate, gotoLogin: true, gotoJobBoard: location?.state?.gotoJobBoard, dispatch: dispatch }))
        }
    }

    const handleClose = () => {
        setIsOpen(false)
        setDataRequired('')
    }
    const submitData = async (data) => {
        setIsOpen(false)
        let bodyData = { ...localBodyData }
        if (dataRequired === 'email') {
            bodyData.email = data
        }
        else if (dataRequired === 'phone') {
            bodyData.phoneNumber = data
        }
        dispatch(socailLogin({ values: bodyData, navigate: navigate, gotoLogin: true, gotoJobBoard: location?.state?.gotoJobBoard, dispatch: dispatch }))
    }
    const handleFB = async (data) => {
        if (data) {
            let bodyData = {}
            if (data?.userID) {
                bodyData.facebookId = data?.userID
            }
            let userAvailabity = await checkUserAvailability(bodyData)
            if (userAvailabity?.result?.isUser) {
                bodyData.isUser = userAvailabity?.result?.isUser
                bodyData.facebookId = data?.userID
                // bodyData.facebookId = ''
            }
            else {
                bodyData.isUser = userAvailabity?.result?.isUser
                bodyData.facebookId = data?.userID
                bodyData.socialType = 'Facebook'
                bodyData.email = data?.email
                // bodyData.phoneNumber = ''
                bodyData.fname = data?.name.split(" ")[0] ?? ''
                bodyData.lname = data?.name.split(" ")[1] ?? ''
                bodyData.name = data?.name

            }
            dispatch(socailLogin({ values: bodyData, navigate: navigate, gotoLogin: true, gotoJobBoard: location?.state?.gotoJobBoard, dispatch: dispatch }))
        }
    }
    return (
        <div className="d-flex justify-content-center">
            <ul className='list-unstyled d-flex'>
                <li className="btn btn-icon btn-label-google-plus me-3">
                    <FontAwesomeIcon icon={faGoogle} />
                    <div className={`social-component`}>
                        <GoogleLogin
                            onSuccess={credentialResponse => {
                                handleCredentialResponse(credentialResponse);
                            }}
                            onError={() => {
                                console.log('Login Failed');
                            }}
                        />
                    </div>
                </li>
                <li className="btn btn-icon  btn-label-facebook me-3">
                    <FontAwesomeIcon icon={faFacebookF} />
                    <div className={`social-component`}>
                        <ReactFacebookLogin
                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                            fields="name,email,picture"
                            callback={handleFB}
                            textButton={'Sign in with Facebook'}
                        />
                    </div>
                </li>
            </ul>

            <AdditionalDataModal
                handleClose={handleClose}
                submitData={submitData}
                type={dataRequired}
                isOpen={isOpen}
            />
        </div>
    )
}

export default SocialSignIn